import moment from 'moment'

const calculateDate = datetime => moment(datetime).format('MMM DD, YYYY');
const calculateDateTimeUK = datetime => moment(datetime).format('Do MMM, YYYY @ HH:MM');

export {
    calculateDate,
    calculateDateTimeUK,
}
